import { Component, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent extends BaseModal implements OnInit {
  isFiliz: boolean = false;
  constructor(private storageService: StorageService, private modalService: ModalService) {
    super();
    super._modalService = modalService;
    this.storageService.get(StorageKeys.FILIZ_MODE).then(e => {
      if (e) {
        this.isFiliz = true;
      } else {
        this.isFiliz = false;
      }
    })
  }

  ngOnInit() {
    super.ngOnInit();
   }

}
